import { useCallback, useState } from 'react';

/**
 * Tracks which rows of the mobile card layout are expanded.
 * Every statistics table needs the exact same accordion behaviour.
 */
export function useExpandableRows<Id extends string | number>() {
    const [expandedRows, setExpandedRows] = useState<Id[]>([]);

    const toggleRow = useCallback((id: Id) => {
        setExpandedRows(prev => prev.includes(id)
            ? prev.filter(item => item !== id)
            : [...prev, id]);
    }, []);

    const isExpanded = useCallback(
        (id: Id) => expandedRows.includes(id),
        [expandedRows],
    );

    return { isExpanded, toggleRow };
};
